import React from 'react';
import PdfViewer from './PdfViewer';

const URL_PDF = 'https://global.divhunt.com/b69b4cfeb9a410fbe1db9758efc3b7c9_230528.pdf';

export default function ObjectionGuide() {
  return (
    <PdfViewer
      eyebrow="Objection & churn handling"
      title="Win more clients. Keep them longer."
      intro="Our objection handling guide. View it here, open it full screen, or download a copy."
      url={URL_PDF}
      frameTitle="Objection handling guide"
    />
  );
}